export type HealthStatus = "green" | "yellow" | "red";

export function safetyHealth(breaches: number): HealthStatus {
  if (breaches === 0) return "green";
  if (breaches <= 5) return "yellow";
  return "red";
}

export function qualityHealth(reworkRate: number): HealthStatus {
  if (reworkRate < 5) return "green";
  if (reworkRate <= 10) return "yellow";
  return "red";
}

export function deliveryHealth(completionRate: number): HealthStatus {
  if (completionRate > 90) return "green";
  if (completionRate >= 80) return "yellow";
  return "red";
}

export function inventoryHealth(openCount: number): HealthStatus {
  if (openCount < 100) return "green";
  if (openCount <= 200) return "yellow";
  return "red";
}

export function productivityHealth(utilization: number): HealthStatus {
  if (utilization > 80) return "green";
  if (utilization >= 60) return "yellow";
  return "red";
}
